import { getWhatsAppGoWsUrl } from "../config";
import { getStoredToken } from "./authToken";

let socket = null;
let reconnectTimer = null;
let backoffMs = 1000;
const maxBackoffMs = 30000;
let lastParams = null;

const messageHandlers = new Set();
const openHandlers = new Set();

function dispatchMessage(event) {
	messageHandlers.forEach((fn) => {
		try {
			fn(event);
		} catch (e) {
			console.error("socketv2 message handler:", e);
		}
	});
}

function notifyOpen() {
	openHandlers.forEach((fn) => {
		try {
			fn();
		} catch (e) {
			console.error("socketv2 open handler:", e);
		}
	});
}

function clearReconnectTimer() {
	if (reconnectTimer) {
		clearTimeout(reconnectTimer);
		reconnectTimer = null;
	}
}

function scheduleReconnect() {
	if (!lastParams?.userId) return;
	clearReconnectTimer();
	reconnectTimer = setTimeout(() => {
		reconnectTimer = null;
		if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) {
			return;
		}
		startSocket();
	}, backoffMs);
	backoffMs = Math.min(backoffMs * 2, maxBackoffMs);
}

function closeSocketInstance() {
	clearReconnectTimer();
	if (socket) {
		try {
			socket.close();
		} catch {
			// ignore
		}
		socket = null;
	}
}

function startSocket() {
	if (!lastParams?.userId) return;
	if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) {
		return;
	}

	const ws = new WebSocket(getWhatsAppGoWsUrl());
	socket = ws;

	ws.addEventListener("message", dispatchMessage);

	ws.addEventListener("open", () => {
		backoffMs = 1000;
		ws.send(
			JSON.stringify({
				usuario: lastParams.userId,
				company: lastParams.companyId || 0,
				token: getStoredToken(),
			})
		);
		notifyOpen();
	});

	ws.addEventListener("error", (err) => {
		console.log("Erro no websocket:", err);
	});

	ws.addEventListener("close", () => {
		console.log("Conexão WebSocket encerrada");
		ws.removeEventListener("message", dispatchMessage);
		if (socket === ws) {
			socket = null;
		}
		scheduleReconnect();
	});
}

function paramsChanged(a, b) {
	if (!a || !b) return true;
	return a.userId !== b.userId || String(a.companyId ?? 0) !== String(b.companyId ?? 0);
}

export function resetGoWebSocket() {
	clearReconnectTimer();
	backoffMs = 1000;
	messageHandlers.clear();
	openHandlers.clear();
	lastParams = null;
	closeSocketInstance();
}

export function connectSocket({ userId, companyId }) {
	if (!userId) return null;
	const next = { userId, companyId };
	if (lastParams && paramsChanged(lastParams, next)) {
		clearReconnectTimer();
		backoffMs = 1000;
		closeSocketInstance();
	}
	lastParams = next;
	if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) {
		return socket;
	}
	startSocket();
	return socket;
}

export function getGoWebSocket() {
	return socket;
}

export function addGoWebSocketMessageHandler(fn) {
	messageHandlers.add(fn);
	return () => messageHandlers.delete(fn);
}

export function addGoWebSocketOpenHandler(fn) {
	openHandlers.add(fn);
	if (socket && socket.readyState === WebSocket.OPEN) {
		try {
			fn();
		} catch (e) {
			console.error("socketv2 open handler (immediate):", e);
		}
	}
	return () => openHandlers.delete(fn);
}
